import tenants from "@/http/requests/tenants"
import { exception } from "vue-analytics";

export default {
    async getAllTenants({commit}, data) {
        try {
            let response = await tenants.getAllTenants(data.token, data.filterUsers ? data.filterUsers : false);
            commit('setTenants', {tenants: response});
        } catch(Exception) {
            console.log(Exception)
            commit('setTenants', {tenants: []});
        }
    },
    async fetchPaginatedTenants({commit}, data) {
        return new Promise((resolve, reject) => {
            tenants.fetchPaginatedTenants(data.token, data.filterUsers, data.page, data.limit, data.search, data.sortName, data.sortType).then(
                response => {
                    commit('SET_PAGINATED_TENANTS', response.data);
                    resolve(response.data);
                }
            ).catch(exception => reject(exception));
        });
    },
    addTenant(context, object) {
        try {
            return new Promise((resolve, reject) => {
                tenants.addTenant(object.token, object.name, object.cnpj, object.features, object.template, object.pool, object.userLimit, object.plan, object.ticketLimit)
                .then((response) => {
                    resolve(response);
                })
                .catch((exception) => {
                    reject(exception);
                });
            });
            
        } catch(Exception) {
            console.log(Exception);
            throw Exception;
        }
    },
    async setCurrentTenant({commit}, {tenant}) {
        commit('setCurrentTenant', {tenant: tenant});
    },
    deleteTenant({commit}, hostnameId, token) {
        return new Promise((resolve, reject) => {
            tenants.deleteTenant(hostnameId, token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getOrders({commit}, data) {
        return new Promise((resolve, reject) => {
            tenants.getOrders(data.startAt, data.finishAt, data.byDay, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getAttendances({commit}, data) {
        return new Promise((resolve, reject) => {
            tenants.getAttendances(data.startAt, data.finishAt, data.websiteId, data.estimation, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    countPerPool({commit}, data) {
        return new Promise((resolve, reject) => {
            tenants.countPerPool(data.filterByEnvironment, data.token).then(response => {
                commit('SET_COUNT_PER_POOL', response.data);
                resolve(response);
            }).catch(exception => reject(exception));
        });
    },
    getInstanceLogs({commit}, data) {
        return new Promise((resolve, reject) => {
            tenants.getInstanceLogs(data.startAt, data.finishAt, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getReasons({commit}, data) {
        return new Promise((resolve, reject) => {
            tenants.getReasons(data.token, data.startAt, data.finishAt, data.tenancyId, data.reasonId).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    restoreTenant({commit}, hostnameId, token) {
        return new Promise((resolve, reject) => {
            tenants.restoreTenant(hostnameId, token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    updateTenantPlan({commit}, data) {
        return new Promise((resolve, reject) => {
            tenants.updateTenantPlan(data.token, data.id, data.plan, data.user, data.ticket).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getFeatures({commit}, data) {
        return new Promise((resolve, reject) => {
            tenants.getFeatures(data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    syncAnalytics({commit}, data) {
        return new Promise((resolve, reject) => {
            tenants.syncAnalytics(
                data.fromDate,
                data.toDate,
                data.forceUpdate,
                data.tenantName,
                data.token
            ).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    updateFeatures({commit}, data) {
        return new Promise((resolve, reject) => {
            tenants.updateFeatures(data.features, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateCampaignStatusWebhook(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateCampaignStatusWebhook(data.startAt, data.finishAt, data.type, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateAttendanceProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateAttendanceProductivityReport(data.fromDate, data.toDate, data.selectedUsers, data.email, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateCampaignProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateCampaignProductivityReport(data.fromDate, data.toDate, data.type, data.email, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateOperatorProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateOperatorProductivityReport(data.fromDate, data.toDate, data.selectedUsers, data.email, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateOrderProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateOrderProductivityReport(data.fromDate, data.toDate, data.email, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateLoginFailuresProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateLoginFailuresProductivityReport(data.fromDate, data.toDate, data.selectedUsers, data.email, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateGradeProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateGradeProductivityReport(data.fromDate, data.toDate, data.selectedUsers, data.email, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateMariaProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateMariaProductivityReport(data.fromDate, data.toDate, data.selectedUsers, data.email, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    diagnoseInstance(_, data) {
        return new Promise((resolve, reject) => {
            tenants.diagnoseInstance(data.instanceId, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getCampaigns(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getCampaigns(data.type, data.page, data.limit, data.searchQuery, data.orderQuery, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    restartCampaign(_, data) {
        return new Promise((resolve, reject) => {
            tenants.restartCampaign(data.campaignId, data.minutes, data.messages, data.startAt, data.finishAt, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getFinishedTicketsRank(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getFinishedTicketsRank(data.from, data.to, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    undoFinishedTickets(_, data) {
        return new Promise((resolve, reject) => {
            tenants.undoFinishedTickets(data.userId, data.from, data.to, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getInstances(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getInstances(data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    }
}
